import { Form } from "antd";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { SitesVirtualSitesTable } from "./SitesVirtualSitesTable";

export const SitesVirtualSitesTableField: FieldMethod = ({ field, readOnly }: FormFieldFactoryProps) => {
    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <SitesVirtualSitesTable key={field.name} readOnly={readOnly} />
        </Form.Item>
    );
};
